import React, { Component } from "react";
import PropTypes from "prop-types";
import Headercontainer from "../container/Headercontainer.js";
import ThankyouHerocontainer from "../container/ThankyouHerocontainer";
import ThankyouArticleList from "../container/ThankyouArticleList";
import LegalFooter from "../container/LegalFooter.js";
import Footercontainer from "../container/Footercontainer.js";
import Scrollupcontainer from "../container/Scrollupcontainer.js";
import axios from "axios";
import deserializeJSON from "../lib/jsonUtils.js";
// import {getFptiEventForFormSubmit} from '../lib/analytics-helper';

class ThankyouMainComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      attachUrl: "",
      slugId: "",
      countryName: "",
      localeName: ""
    };
  }

  componentDidMount() {
    if (window.sessionStorage.slugId && 
        window.sessionStorage.localeName && 
        window.sessionStorage.countryName && 
        window.sessionStorage.slugId !== ""
      ) {
      this.setState({
        slugId: window.sessionStorage.slugId, 
        localeName: window.sessionStorage.localeName, 
        countryName: window.sessionStorage.countryName,
      });
    }
    const hrefUrl = window.location.href;
    if (hrefUrl.indexOf("?locale.x") !== -1) {
      this.setState({
        attachUrl: hrefUrl.split("?")[1],
      });
    }
  }
  handlePdf(slugId) {
    // let self = this;
    axios
      .get("/brc/getPDFUrl", {
        params: {
          slugID: slugId,
        },
      })
      .then(function (response) {
        const gatewayInfo = deserializeJSON(response.data.results);
        const pdfURL = gatewayInfo["pdf-link"];
        const appendHttp = `https://${pdfURL}`;
        if (pdfURL.substring(0, 4) === "http") {
          window.open(pdfURL, "_blank");
        } else {
          window.open(appendHttp, "_blank");
        }
        // getFptiEventForFormSubmit(
        //   self.props.country,
        //   self.props.locale,
        //   content && content.eloquaFormName,
        //   "Success",
        //   "form_validation",
        //   "brcArticle",
        //   "download-gateway:" + self.props.slugId,
        //   self.props.userAccountInfo,
        //   self.props.encryptedAccountNumber,
        //   self.state.cookies && self.state.cookies.includes("isFormSubmitted")
        // );
      })
      .catch(function (error) {
        console.log("error", error.message);
      });
  }
  render() {
    const legalFooter = JSON.parse(this.props.legalFooter);
    const {
      header,
      country,
      locale,
      isLoggedIn,
      useGlobalNav,
      isNewMppEnabled,
      footer,
      colors,
      topicsHash,
      tilesInfo,
      categorieValues,
    } = this.props;
    const {slugId, localeName, countryName} = this.state;
    const isDownloadBtnExist = slugId!=="" && countryName!=="" && localeName!=="" && country.toLowerCase() === countryName && locale === localeName ? true : false;

    return (
      <div className="brcarticle-main-component">
        <Headercontainer
          header={header}
          country={country}
          locale={locale}
          isLoggedIn={isLoggedIn}
          useGlobalNav={useGlobalNav}
          isNewMppEnabled={isNewMppEnabled}
        />
        <ThankyouHerocontainer 
          categorieValues={categorieValues} 
          slugId={slugId} 
          isDownloadBtnExist={isDownloadBtnExist} 
        />
        <ThankyouArticleList
          locale={locale}
          colors={colors}
          topicsHash={topicsHash}
          country={country}
          attachUrl={this.state.attachUrl}
          articles={JSON.parse(tilesInfo)}
        />
        <LegalFooter
          country={country}
          locale={locale}
          legalFooter={legalFooter}
        />
        <Footercontainer
          footer={footer}
          country={country}
          locale={locale}
          isNewMppEnabled={isNewMppEnabled}
          useGlobalNav={useGlobalNav}
        />
        <Scrollupcontainer />
      </div>
    );
  }
}

export default ThankyouMainComponent;

ThankyouMainComponent.propTypes = {
  header: PropTypes.string,
  country: PropTypes.string,
  isLoggedIn: PropTypes.string,
  useGlobalNav: PropTypes.string,
  isNewMppEnabled: PropTypes.string,
  footer: PropTypes.string,
};
